import angular from 'angular';
import uiRouter from 'angular-ui-router';
import SpendingTypeComponent from './spending-type.component';

let SpendingTypeModule = angular.module('SpendingType', [
    uiRouter
])

.config(($stateProvider) => {
    'ngInject';
    $stateProvider
        .state('newSpendingType', {
            url: '/spendingTypes/new',
            component: 'spendingType',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
            }
        })
        .state('editSpendingType', {
            url: '/spendingTypes/:id',
            component: 'spendingType',
            parent: 'main',
            data: {
                permissions: {
                    only: ['ADMIN'],
                    redirectTo: 'home'
                }
            },
            resolve: {
                spendingType: (
                    SpendingTypesService,
                    $stateParams
                ) => {
                    return SpendingTypesService.findOne({
                        filter: {
                            where: {
                                id: $stateParams.id
                            },
                            include: [],
                            deleted: true
                        }
                    });
                }
            }
        });
})
.component('spendingType', SpendingTypeComponent)
.name;

export default SpendingTypeModule;
